import nativeToJsPlugin from './nativeToJsPlugin';
import { bluetoothDoScan, bluetoothEnable } from '@/tools/nativeInterfaceFunctions';
import { mutationTypes, actionTypes } from '@/types';
import { logger } from '@/tools';

export default {
	state: {
		isActive: false,
		currentBeaconDescriptionSubset: {},
		beaconDescription: {},
		rawDetectedBeacons: {},
		detectedBeacons: {},
		medianWindow: [],
		config: {
			androidBias: 0,
			beaconTimeout: 5000,
			iosBias: 0,
			medianWindowWidth: 0,
			notSeenForOneScanMalus: 0,
			onlyExhibitionBeacons: true,
			rssiFilterAlpha: 0,
			scanInterval: 1500,
			activateBluetooth: false,
			mergeExhibitionBeacons: false,
		},
		rawScan: {
			shoutrBeaconURL: null,
			mac: null,
			rssi: null,
			power: null,
			accuracy: null,
			proximity: null,
		},
	},
	getters: {},
	mutations: {
		[mutationTypes.bluetoothRawScan](state, { rawScan }) {
			state.rawScan = Object.assign({}, rawScan);
		},
		[mutationTypes.bluetoothStart](state) {
			state.isActive = true;
		},
		[mutationTypes.bluetoothStop](state) {
			state.isActive = false;
		},
		[mutationTypes.bluetoothToggle](state, { value }) {
			state.isActive = value;
		},
		[mutationTypes.bluetoothSetScanConfig](state, config) {
			state.config = Object.assign(state.config, config);
			if (state.config.activateBluetooth) {
				// activate Bluetooth
				bluetoothEnable();
			}
		},
		[mutationTypes.bluetoothSetBeaconDescription](state, { beaconDescription }) {
			state.beaconDescription = beaconDescription;
		},
		[mutationTypes.bluetoothSetBeaconDescriptionSubset](state, { beaconDescription }) {
			state.currentBeaconDescriptionSubset = beaconDescription;
			// remove Beacons which are not in the new subset
			Object.keys(state.rawDetectedBeacons).forEach(beaconID => {
				if (!beaconDescription[beaconID]) {
					delete state.rawDetectedBeacons[beaconID];
				}
			});
		},
		[mutationTypes.bluetoothUpdateRawDetecedBeacons](
			state,
			{ shoutrBeaconURL, rssi, accuracy, proximity, beaconDesc }
		) {
			// RSSI value higher then Threshold map beacon
			if (typeof state.rawDetectedBeacons[shoutrBeaconURL] === 'undefined') {
				// check if Beacon seen First time
				state.rawDetectedBeacons[shoutrBeaconURL] = Object.assign(
					{ url: shoutrBeaconURL, firstTimeinScanTic: true },
					beaconDesc
				);
			}
			const currentbeacon = state.rawDetectedBeacons[shoutrBeaconURL];
			currentbeacon.lastSeen = performance.now();
			if (currentbeacon.firstTimeinScanTic) {
				currentbeacon.firstTimeinScanTic = false;
				currentbeacon.rssi = rssi;
				currentbeacon.accuracy = accuracy;
				currentbeacon.proximity = proximity;
			} else {
				currentbeacon.rssi =
					(state.config.rssiFilterAlpha || 0) * currentbeacon.rssi +
					(1 - (state.config.rssiFilterAlpha || 0)) * rssi;
				currentbeacon.accuracy = currentbeacon.accuracy;
				currentbeacon.proximity = proximity;
			}
		},
		[mutationTypes.bluetoothScanStep](state) {
			logger.log('store.state.medianWindow:', state.rawDetectedBeacons);

			const tmpTimeStamp = performance.now();
			// remove old beacons
			Object.entries(state.rawDetectedBeacons).forEach(([url, beacon]) => {
				beacon.firstTimeinScanTic = true;
				if (tmpTimeStamp - beacon.lastSeen > state.config.beaconTimeout) delete state.rawDetectedBeacons[url];
				else {
					if (parseInt(tmpTimeStamp - beacon.lastSeen) > state.config.scanInterval) {
						beacon.rssi -= state.config.notSeenForOneScanMalus || 0;
					} else {
						beacon.rssi += beacon.bias;
					}
				}
			});

			// logger.log('DetectedBeacibs Beacons', rawDetectedBeacons);
			if (state.medianWindowWidth >= 3) {
				state.medianWindow.push(JSON.parse(JSON.stringify(state.rawDetectedBeacons)));
				while (state.medianWindow.length > state.medianWindowWidth) {
					state.medianWindow.shift(); // pull last element to contain window.length
				}
				// Get all scanned Beacons of the las medianWindoLenght tics
				const filteredBeacons = JSON.parse(JSON.stringify(Object.assign(...state.medianWindow)));

				Object.keys(filteredBeacons).forEach(shoutrBeaconURL => {
					filteredBeacons[shoutrBeaconURL].rssi = state.medianWindow
						// For every tic beacon has vanished set rssi to -100 so median can be calculated
						.map(ticResult => (ticResult[shoutrBeaconURL] ? ticResult[shoutrBeaconURL].rssi : -100))
						// sort them and get median rssi value
						.sort((a, b) => a - b)[Math.round(state.medianWindow.length / 2)];
				});
				state.detectedBeacons = filteredBeacons;
			} else {
				state.detectedBeacons = JSON.parse(JSON.stringify(state.rawDetectedBeacons));
			}
			// logger.log('BeaconScan step result:', state.detectedBeacons);
		},
	},

	actions: {
		async [actionTypes.startBluetooth]({ commit, state, rootState }) {
			if (!rootState.isApp) return;

			if (state.isActive) {
				logger.warn('Bluetooth already started');
			} else {
				const result = await bluetoothDoScan(true);
				logger.log('native Bluetooth activated', result);
				commit(mutationTypes.bluetoothStart);
			}
		},
		async [actionTypes.stopBluetooth]({ commit, state }) {
			if (!state.isActive) {
				logger.warn('Bluetooth already stopped');
			} else {
				const result = await bluetoothDoScan(false);
				logger.log('native Bluetooth activated', result);
				commit(mutationTypes.bluetoothStop);
			}
		},
	},
	plugins: [nativeToJsPlugin],
};
